import { RemoteLoadResourcePlaceList } from '@/javascript/data/usecases'
import { LoadResourcePlaceList } from '@/javascript/domain/usecases'
import { makeCurrentAccountHttpClientDecorator } from '@/javascript/main/factories/decorators'
import { makeApiUrl } from '../http'

export const makeRemoteLoadResourcePlaceList = (): LoadResourcePlaceList =>
  new RemoteLoadResourcePlaceList(makeApiUrl('/resource_places'), makeCurrentAccountHttpClientDecorator())